// Paste the Google Apps Script web app URL after you deploy it. Empty = submit shows an error.
window.TPS_SHEET_ENDPOINT = 'https://script.google.com/macros/s/AKfycbypUq69cZ6HTLuuAQkn-bnF1aZibrQaguOHoPUPpxGecVNlJ0uzJhopQuw3ceoOGn986w/exec';

(function () {
  var SEL = 'cart-drawer,#cart-drawer,#shopify-section-cart-drawer,#rebuy-cart,.rebuy-cart,#rebuy-bubble,.rebuy-cart__flyout,.rebuy-cart__background';
  var CSS = SEL + '{display:none!important}';

  function kill() {
    var root = document.documentElement;
    if (!root) return;
    var head = document.head || root;
    if (!head.querySelector('style[data-tps-nocart]')) {
      var style = document.createElement('style');
      style.setAttribute('data-tps-nocart', '');
      style.appendChild(document.createTextNode(CSS));
      head.appendChild(style);
    }
    var nodes = root.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) nodes[i].remove();
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.destroy) {
        window.Rebuy.SmartCart.destroy();
      }
    } catch (e) {}
  }

  kill();
  new MutationObserver(kill).observe(document, { childList: true, subtree: true });
  document.addEventListener('rebuy:smartcart.ready', kill);
  document.addEventListener('rebuy.ready', kill);
  document.addEventListener('rebuy:cart.ready', kill);
})();
